import {createReducer, on} from '@ngrx/store';
import * as MultishareHistoryActions from './multishare-history.actions';
import {Page} from '../../components/common-interfaces';
import {Share} from '../domain';

export const multishareHistoryFeatureKey = 'multishareHistory';
const emptyPage = <Page<Share>>{content: [], totalElements: -1};

export interface State {
  histories: Page<Share>
}

export const initialState: State = {
  histories: emptyPage
};

export const reducer = createReducer(
  initialState,
  on(MultishareHistoryActions.loadMultishareHistorysSuccess, (state, action) => ({
    ...state,
    histories: action.historiesPage
  })),
);
